export default __webpack_public_path__ + "static/media/3DLogo.79ee3f0e.png";